import { render, staticRenderFns } from "./Absence.vue?vue&type=template&id=68a80640&"
import script from "./Absence.vue?vue&type=script&lang=js&"
export * from "./Absence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports